// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__p7XuO","productName":"Table_productName__vU6PX"};